import { Box, IconButton, Typography } from "@mui/material";
import React, { memo } from "react";
import { Bin } from "../../../store/card/types";
import {
  Edit,
  Delete,
  CheckCircle,
  RadioButtonUnchecked,
} from "@mui/icons-material";
import { AddEditBinParams, accounts } from "./BinForm";
import { includes } from "ramda";

interface BinItemProps {
  bin: Bin;
  cardBinIndex: number;
  binIndex: number;
  setBinEditAddDialogData: (params: AddEditBinParams) => void;
  setDeleteItemId: (value: number) => void;
  setShowConfirm: (value: boolean) => void;
}

const classes = {
  binItem: {
    padding: 1,
    display: "flex",
    borderTop: "1px solid #efefef",
    alignItems: "center",

    "& *": {
      boxSizing: "border-box",
    },
  },
  binTitle: {
    background: "#fafafa",
    padding: 1,
    fontSize: 13,
    display: "flex",
  },
  binValuesCol: {
    width: 100,
    marginRight: 2,
    fontSize: 14,
  },
  binAccountsCol: {
    flex: 1,
    marginLeft: 1,
  },
  binActionCol: {
    width: 100,
  },
  accTypo: {
    fontSize: 14,
    margin: "0 10px 0 5px",
  },
  icon: {
    color: "rgba(0, 0, 0, 0.3)",
  },
};

const BinItem = (props: BinItemProps) => {
  const {
    bin,
    cardBinIndex,
    binIndex,
    setBinEditAddDialogData,
    setDeleteItemId,
    setShowConfirm,
  } = props;

  const handleDeleteBin = (binIndex: number) => {
    setDeleteItemId(binIndex);
    setShowConfirm(true);
  };

  const handleEditBin = (cardBinIndex: number, binIndex: number) => {
    setBinEditAddDialogData({
      isOpen: true,
      isAddNew: false,
      cardBinIndex,
      binIndex,
      binData: bin,
    });
  };

  return (
    <Box sx={classes.binItem}>
      <Box sx={classes.binValuesCol}>{bin.From}</Box>
      <Box sx={classes.binValuesCol}>{bin.To}</Box>
      <Box sx={classes.binValuesCol}>{bin.Length}</Box>
      <Box sx={classes.binAccountsCol} display="flex">
        {accounts.map((account, accIdx) => {
          return (
            <Box key={accIdx} display="flex" alignItems="center">
              {includes(account, bin.Account) ? (
                <CheckCircle fontSize="small" sx={classes.icon} />
              ) : (
                <RadioButtonUnchecked fontSize="small" sx={classes.icon} />
              )}{" "}
              <Typography sx={classes.accTypo}>{account}</Typography>
            </Box>
          );
        })}
      </Box>
      <Box sx={classes.binActionCol}>
        <IconButton
          aria-label="delete"
          onClick={() => handleEditBin(cardBinIndex, binIndex)}
        >
          <Edit />
        </IconButton>
        <IconButton
          aria-label="delete"
          onClick={() => handleDeleteBin(binIndex)}
        >
          <Delete />
        </IconButton>
      </Box>
    </Box>
  );
};

export default memo(BinItem);
